<template>
    <el-card class="profile">
        <div slot="header" class="clearfix">
            <span>管理员替用户创建云视频会议</span><span class="ml-3"></span>
        </div>

        <div class="mt-3">
            <el-form :model="single" ref="MeetingForm" label-width="100px">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item prop="user_id" label="用户账号:"
                                      :rules="user_id_rule">
                            <el-autocomplete v-model="single.user_id"
                                             :fetch-suggestions="querySearchAsync"
                                             placeholder="请输入用户账号"
                                             :trigger-on-focus="false"
                                             @select="handleSelect"
                                             class="w-100">
                                <template slot-scope="{ item }">
                                    <div class="d-flex justify-content-between">
                                        <div>{{ item.value }}</div>
                                        <small>{{ item.name }}</small>
                                    </div>
                                </template>
                            </el-autocomplete>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item
                            prop="user_name"
                            label="姓名:"
                            :rules="[{ required: true, message: '请输入姓名', trigger: 'blur' },]">
                            <el-input v-model="single.user_name" placeholder="请输入姓名"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item
                            prop="email"
                            label="邮箱:"
                            :rules="[{ required: true, message: '请输入邮箱', trigger: 'blur' },
                                { type: 'email', message: '请输入正确的邮箱', trigger: 'blur' }]">
                            <el-input v-model="single.email"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20" type="flex">
                    <el-col>
                        <el-form-item prop="meeting_date" label="日期:"
                                      :rules="[{ required: true, message: '请输入日期', trigger: 'blur' }]">
                            <el-date-picker class="w-100"
                                            v-model="single.meeting_date"
                                            type="date"
                                            value-format="yyyy-MM-dd"
                                            placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item
                            prop="meeting_time"
                            label="时间:"
                            :rules="[{ required: true, message: '请输入时间', trigger: 'blur' }]">
                            <el-time-select class="w-100"
                                            placeholder="时间"
                                            v-model="single.meeting_time"
                                            :picker-options="{start: '00:00',step: '00:30',end: '23:30',}">
                            </el-time-select>
                        </el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item
                            prop="duration"
                            label="时长:"
                            value-format="HH-mm-ss"
                            :rules="[{ required: true, message: '请输入时长', trigger: 'blur' }]">
                            <el-select v-model="single.duration" placeholder="请选择" class="w-100">
                                <el-option
                                    v-for="item in duration_options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20" type="flex">
                    <el-col>
                        <el-form-item prop="meeting_date" label="周期会议:">
                            <el-switch :inactive-value="0" :active-value="1" v-model="single.recurrent"></el-switch>
                            <div class="float-right ml-3" v-if="single.recurrent">
                                {{ single.recurrent_times ? '结束按次数计算' : '结束按日期计算' }}
                                <el-switch :inactive-value="0" :active-value="1"
                                           v-model="single.recurrent_times"></el-switch>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item v-if="single.recurrent_times"
                                      label="循环次数:">
                            <el-input-number class="w-100"
                                             v-model="single.end_meeting_times"
                                             type="number"
                                             :disabled="!single.recurrent"
                                             :max="50"
                                             :min="1"
                                             placeholder="选择循环次数">
                            </el-input-number>
                        </el-form-item>
                        <el-form-item v-else
                                      label="结束日期:">
                            <el-date-picker class="w-100"
                                            v-model="single.end_meeting_date"
                                            type="date"
                                            :disabled="!single.recurrent"
                                            value-format="yyyy-MM-dd"
                                            placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item
                            prop="repeat"
                            label="重复周期:">
                            <el-select v-model="single.repeat" placeholder="请选择" class="w-100"
                                       :disabled="!single.recurrent">
                                <el-option v-for="x in repeat_options" :key="x.value" :label="x.name"
                                           :value="x.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20" type="flex">
                    <el-col :span="8">
                        <el-form-item
                            prop="room_groups"
                            label="会组:" style="margin-bottom: 0; ">
                            <el-select v-model="single.group_id" placeholder="请选择会议室组" class="w-100">
                                <el-option
                                    v-for="item in allRoomGroups"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item
                            prop="usage"
                            label="用途:" style="margin-bottom: 0; ">
                            <el-select v-model="single.usage" placeholder="填写用途" class="w-100">
                                <el-option
                                    v-for="item in preset.app.usages"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item
                            prop="mobile" v-if="!$organization.use_contact"
                            label="手机:" style="margin-bottom: 0; ">
                            <el-input v-model="single.mobile" placeholder="腾讯会议需要手机" class="w-100">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>


                <el-form-item label="空闲">
                    <meeting-freebusy ref="meeting_busy" :date="single.meeting_date" :h323="single.option_h323"
                                      :group="single.group_id"
                                      :duration="single.duration"
                                      :time="single.meeting_time"
                                      @change='handleFreeChange'>
                    </meeting-freebusy>
                </el-form-item>
                <el-row>
                    <el-col :span="isTencentMeeting?12:18">
                        <el-form-item
                            prop="topic"
                            label="主题:"
                            :rules="[{ required: true, message: '请输入主题', trigger: 'blur' }]">
                            <el-input v-model="single.topic"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item
                            prop="password"
                            label="会议密码:"
                            v-show="roomGroupPlatform != 4">
                            <div class="d-flex">
                                <el-input v-model="single.password"
                                          placeholder="0-8位纯数字"></el-input>
                                <el-button size="mini" @click="makeRandomPassword" class="ml-1"
                                           icon="el-icon-refresh"></el-button>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" v-if="isTencentMeeting">
                        <el-form-item
                            prop="topic"
                            label="联席主持:">
                            <el-input v-model="single.assistants" placeholder="请输入联席主持人工号"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" v-show="isWelinkMeeting">
                        <el-form-item
                            prop="size"
                            label="规模:" style="margin-bottom: 0; ">
                            <el-select v-model="single.size" placeholder="填写规模" class="w-100">
                                <el-option
                                    v-for="item in sizes"
                                    :key="item"
                                    :label="item+'人'"
                                    :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-row :gutter="20">
                        <el-col :span="16">
                            <el-row>
                                <el-form-item
                                    prop="description"
                                    label="描述:">
                                    <el-input type="textarea" v-model="single.description" :rows="2"></el-input>
                                </el-form-item>
                            </el-row>
                            <el-row :gutter="5" type="flex" v-if="'1' !== single.option_enroll">
                                <el-col class="flex-grow-1">
                                    <div class="el-form-item">
                                        <label class="el-form-item__label"
                                               style="width: 100px;color: #2196f3">参会者:
                                        </label>
                                        <div class="el-form-item__content" style="margin-left: 100px;">
                                            <div class="el-textarea">
                                                <div class="el-textarea__inner"
                                                     style="min-height: 60px;">
                                                    <div v-for="item in emails" :key="item.emails"
                                                         style="display: inline-block">
                                                        <el-tooltip effect="light" :content="item.email"
                                                                    placement="top">
                                                            <div class="attendee-block">
                                                                {{ item.name }}
                                                                {{ item.over ? ('&lt;' + item.email + '&gt;') : '' }}
                                                                <div class="icon-button" @click="removeEmail(item)"><i
                                                                    class="fa fa-times-circle"></i></div>
                                                            </div>
                                                        </el-tooltip>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col class="flex-grow-0" style="width: 60px;">
                                    <button style="width: 100%;height: 60px" type="button" class="btn btn-secondary"
                                            @click="handleAddressBook">
                                        <i class="fa fa-address-book-o"></i>
                                    </button>
                                </el-col>
                            </el-row>
                            <el-row v-else>
                                <el-col>
                                    <div class="el-form-item">
                                        <label class="el-form-item__label"
                                               style="width: 100px;color: #2196f3">报名人员:
                                        </label>
                                        <div class="el-form-item__content" style="margin-left: 100px;">
                                            <el-input type="textarea" v-model="single.enroll_attendees" :rows="2"
                                                      placeholder="请输入报名人员ID，或者手机号。用英文逗号或者回行分割"></el-input>
                                        </div>
                                    </div>
                                </el-col>
                            </el-row>
                        </el-col>
                        <el-col :span="8">
                            <el-row type="flex" style="flex-wrap: wrap">
                                <el-form-item style="margin-bottom: 0"
                                              prop="waiting_room"
                                              label="等候室:">
                                    <el-tooltip class="item" effect="light" content="参会者默认进入会议等候室"
                                                placement="top">
                                        <el-switch v-model="single.waiting_room"
                                                   @change="single.option_jbh = single.waiting_room?0:single.option_jbh"
                                                   :active-value="1"
                                                   :inactive-value="0">
                                        </el-switch>
                                    </el-tooltip>
                                </el-form-item>
                                <el-form-item style="margin-bottom: 0"
                                              prop="option_jbh"
                                              label="提前参会:">
                                    <el-tooltip class="item" effect="light" content="在主持人之前加入会议" placement="top">
                                        <el-switch v-model="single.option_jbh"
                                                   @change="single.waiting_room = single.option_jbh?0:single.waiting_room"
                                                   active-value="1"
                                                   inactive-value="0">
                                        </el-switch>
                                    </el-tooltip>
                                </el-form-item>
                                <el-form-item style="margin-bottom: 0;display: none;"
                                              prop="option_mute"
                                              label="静音入会:">
                                    <el-tooltip class="item" effect="light" content="参会者进入会议后默认静音" placement="top">
                                        <el-switch v-model="single.option_mute"
                                                   active-value="1"
                                                   inactive-value="0">
                                        </el-switch>
                                    </el-tooltip>
                                </el-form-item>
                                <el-form-item style="margin-bottom: 0"
                                              prop="option_interpreter"
                                              label="开启同传:">
                                    <el-tooltip class="item" effect="light" content="激活后，开启同传。主持人入会可以设置"
                                                placement="top">
                                        <el-switch v-model="single.option_interpreter"
                                                   active-value="1"
                                                   inactive-value="0">
                                        </el-switch>
                                    </el-tooltip>
                                </el-form-item>
                                <el-form-item style="margin-bottom: 0" v-if="isTencentMeeting"
                                              prop="option_live"
                                              label="开启直播:">
                                    <el-tooltip class="item" effect="light" content="激活后，创建直播链接"
                                                placement="top">
                                        <el-switch v-model="single.option_live"
                                                   active-value="1"
                                                   inactive-value="0">
                                        </el-switch>
                                    </el-tooltip>
                                </el-form-item>
                                <el-form-item style="margin-bottom: 0" v-if="isTencentMeeting && $organization.allow_enroll"
                                              prop="option_enroll"
                                              label="开启报名:">
                                    <el-tooltip class="item" effect="light" content="开启报名后，只有参会名单上的用户才可以入会"
                                                placement="top">
                                        <el-switch v-model="single.option_enroll"
                                                   active-value="1"
                                                   inactive-value="0">
                                        </el-switch>
                                    </el-tooltip>
                                </el-form-item>
                                <el-tooltip class="item" effect="light" content="请选择录制方式，如自动录制则主持人与会后自动录制，但使用主持密码则无效"
                                            placement="top">
                                    <fake-form-item :width="20">
                                        <el-select v-model="single.auto_record" size="small" style="width: 125px;" class="type-primary"
                                                   placeholder="选择录像方案">
                                            <el-option label="手动选择录制" :value="0"></el-option>
                                            <el-option label="自动本地录制" :value="1"></el-option>
                                            <el-option label="自动云端录制" :value="2"></el-option>
                                        </el-select>
                                    </fake-form-item>
                                </el-tooltip>
                            </el-row>
                        </el-col>
                    </el-row>
                </el-row>
            </el-form>
        </div>

        <el-row>
            <div class="line"></div>
            <el-button :loading="is_loading" class="mt-3" type="primary" @click="handleSubmit">
                {{ $organization.use_id ? '创建会议' : '创建并发通知给用户' }}
            </el-button>
        </el-row>

        <address-book-picker :edit_mode="address_book_visible" :address_book="emails" @cancel="handleCancel"
                             @success="handleSuccess">
        </address-book-picker>

    </el-card>
</template>

<script>
import MeetingFreebusy from "../components/Meeting-FreeBusy";
import CreateMixin from "../common/mixins/front-create-mixin";
import AddressBookPicker from "../components/address-book-picker";
import FakeFormItem from "@/components/FakeFormItem";

export default {
    name: "create",
    components: {FakeFormItem, MeetingFreebusy, AddressBookPicker},
    mixins: [CreateMixin],
}
</script>

<style lang="scss">
</style>
